<template>
  <div class="no-permissions">
    <block>
      <h2 slot="header-content">
        {{ $t('noPermissions.title') }}
      </h2>

      <div slot="content">
        {{ $t('noPermissions.desc') }}
      </div>
    </block>
  </div>
</template>

<script>
import Block from './../common/Block';

export default {
  name: 'no-permissions',
  components: {
    'block': Block
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.no-permissions {

}
</style>



// WEBPACK FOOTER //
// src/components/views/NoPermissions.vue